module.exports = __webpack_public_path__ + "img/jiaowu_mobile4.e5fabf6b.jpg";